var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8623 2.1516C11.8431 0.961926 10.8693 0 9.67512 0H2.1875C0.981313 0 0 0.981313 0 2.1875V9.66145C0 10.851 0.954352 11.8218 2.13765 11.8484C2.1569 13.0381 3.13067 14 4.32488 14H11.8125C13.0187 14 14 13.0187 14 11.8125V4.33855C14 3.14899 13.0456 2.17815 11.8623 2.1516ZM2.68425 10.7552H2.1875C1.58441 10.7552 1.09375 10.2645 1.09375 9.66145V2.1875C1.09375 1.58441 1.58441 1.09375 2.1875 1.09375H9.67512C10.2782 1.09375 10.7689 1.58441 10.7689 2.1875V9.66145C10.7689 10.2645 10.2782 10.7552 9.67512 10.7552H2.68425ZM12.9062 11.8125C12.9062 12.4156 12.4156 12.9062 11.8125 12.9062H4.32488C3.73398 12.9062 3.25101 12.4353 3.23173 11.8489H9.67515C10.8813 11.8489 11.8626 10.8676 11.8626 9.66145V3.24592C12.4426 3.27217 12.9063 3.75222 12.9063 4.33852V11.8125H12.9062Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.0ed9a8292b1fa0cbd1ebd452f466d518.svg";
export { ForwardRef as ReactComponent };